import { addRemoteConversation } from "src/chat";
import { createConversation } from "src/chat/api";
import api from "src/spintr/SpintrApi";

interface IChatPerson {
    id: number;
    name: string;
    /** The existing conversation with the person, if there is one. */
    conversationId?: number;
}

/**
 * Opens the chat with a person: the existing conversation, or a new one.
 * In the app the conversation is handed to the native chat as well.
 */
export const openPersonChat = (
    person: IChatPerson,
    currentUserId: number,
    appMode: boolean,
    dispatch: any,
    history: any,
): void => {
    const openConversation = (c: any) => {
        dispatch(addRemoteConversation(c));
        history.push("/groups/chat/" + c.id);
    };

    const postToApp = (conversationId: number) => {
        const chatObject = {
            conversationId,
            userId: person.id,
            userName: person.name
        };

        //@ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify(chatObject));
    };

    if (!person.conversationId) {
        const defaultUser: Spintr.IUser = {
            id: 0,
            name: "",
            imageUrl: "",
            info: "",
            typeName: "",
            type: 0
        };

        const participants: Spintr.IUser[] = [{
            ...defaultUser,
            id: person.id,
        }, {
            ...defaultUser,
            id: currentUserId,
        }];

        createConversation(participants).then((response) => {
            if (appMode) {
                postToApp(response.data.id);
            }

            openConversation(response.data);
        }).catch(() => { });

        return;
    }

    api.get("/api/v1/conversations/" + person.conversationId).then((response) => {
        if (appMode) {
            postToApp(response.data.id);
        } else {
            openConversation(response.data);
        }
    }).catch(() => { });
};
